import { render, staticRenderFns } from "./popup_build_the_beat.vue?vue&type=template&id=3866d98b&"
import script from "./popup_build_the_beat.vue?vue&type=script&lang=js&"
export * from "./popup_build_the_beat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LanguageSelection: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/language_selection.vue').default})
